import './noResults.css'

export default function NoResults(){
   return( <div className="noResults">
        No results available.
    </div>)
}